module.exports = __webpack_public_path__ + "assets/assets/images/about/emotional.e3f28c6e.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/emotional.png
// module id = 548
// module chunks = 0